import React, { useContext } from "react";
import SearchFilters from "../components/SearchFilters/SearchFilters";
import { FilterContext } from "contextos/FilterContext";

export default function TreeView(props) {
  const { handleSubmit } = useContext(FilterContext);
  return (
    <div className="row py-2 sticky-top shadow-sm rounded">
      <form action={``} onSubmit={handleSubmit} name="searchForm">
        <SearchFilters />
      </form>
    </div>
  );
}
